import {EventEmitter, Injectable} from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

// import { Store } from '@ngrx/store';
// import {UPDATESTATE} from '../reducers/search-state';

export interface SearchCriteria {
  searchTerm?: string;
  searchType?: string;
  pageNum?: number;
  state?: string;
  cities?: Array<string>;
  counties?: Array<string>;
}

@Injectable()
export class SearchService {
  constructor(private apollo: Apollo) { }

  /* searchType can be one of the following:
   all
   person
   hospital
   system
   */

  advancedSearch(searchCriteria: SearchCriteria)
  {
    const query = gql`
      query Search($searchTerm: String, $searchType: String, $state: String, $cities: [String], $counties: [String], $pageNum: Int!) {
        search(searchTerm: $searchTerm, searchType: $searchType, state: $state, city: $cities, county: $counties, pageNum: $pageNum) {
          total
          start
          pageLength
          result {
            index
            resultType
            orgDisplayName
            systemDisplayName
            region
            personDisplayName
            title
            address
            ahaId
            ahaMember
            affiliateUnitOf
          }
          facet {
            name
            facetValue
          }
          error
        }
      }
    `;

    return this.apollo.watchQuery<any>({query: query, variables: searchCriteria});
  }

  typeAhead(searchCriteria: SearchCriteria)
  {
    const query = gql`
    query GetSearchSuggestions($searchTerm: String, $searchType: String) {
      searchSuggestion(searchTerm: $searchTerm, searchType: $searchType)
    }
    `;

    return this.apollo.watchQuery<any>({query: query, variables: searchCriteria});
  }

  newSearch = new EventEmitter<string>();

}



// WEBPACK FOOTER //
// ./src/app/common/services/search.service.ts